<template>
  <div class="mt-8">
    <div class="intro-y box p-5 mt-5">
      <div class="flex items-center h-10">
        <h2 class="text-lg font-bold truncate mr-5">资产管理列表</h2>
        <div class="ml-auto">
          <el-button type='primary'  @click="manualEntry"> 手工录入资产</el-button>
          <el-button type='primary' @click="tableImport"> 表格导入资产</el-button>
        </div>
      </div>
      <div class="flex items-center h-10">
        <div>
          <el-cascader :options="unitOptions" :show-all-levels="false" size="medium"
                       :props='cascaderProps' placeholder="请选择管理单位" @change="onChange" v-model="companyIds"></el-cascader>
          <el-select v-model="form.userId" placeholder="请选择" size="medium" style="margin-left:10px;">
            <el-option
              v-for="item in staffOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button style='margin-left: 20px;' type='primary' @click="checkData">查询</el-button>
        </div>
        <a href="javascript:;" class="ml-auto flex text-theme-1 dark:text-theme-10" @click="getTemplate">
          导入资产模板下载
        </a>
      </div>
    </div>
    <!-- 导入成功提示框 -->
      <div class="success-dialog import-dialog" ref="successDialog">
      <el-dialog
        :visible.sync="successVisible"
        width="460px"
        top="calc(50vh - 105px)">
          <div slot="title" class="dialog-title" style="font-size:18px;color:#303133;">
            <i class="el-icon-success" style="color:#67C23A;font-size:22px;"></i>
            &nbsp;资产导入成功
          </div>
        <p>共 {{importResult.totalNum}} 资产，导入成功 {{importResult.successNum}} 资产</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="hideModalSuccess">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 导入错误提示框 -->
    <div class="error-dialog import-dialog" ref="errorDialog">
      <el-dialog
        :visible.sync="errorVisible"
        width="460px" top="calc(50vh - 105px)">
          <div slot="title" class="dialog-title" style="font-size:18px;color:#303133;">
            <i class="el-icon-error" style="color:#F56C6C;font-size:22px;"></i>
            <span>&nbsp;导入失败-{{importResult.errorDesc}}</span>
          </div>
        <p>共 {{importResult.totalNum}} 资产，导入成功 {{importResult.successNum}} 资产，导入失败 {{importResult.failureNum}} 资产</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" @click="hideModalError">取消</el-button>
          <el-button type="primary" @click="hideModalError">重新上传</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 上传进度提示框 -->
    <div class="progress-dialog import-dialog" ref="progressDialog">
      <el-dialog
        :visible.sync="progressVisible"
        width="460px" top="calc(50vh - 105px)">
        <div slot="title" class="dialog-title" style="font-size:18px;color:#303133;">
          <span>正在导入资产...</span>
        </div>
        <div class="progress-dv">
          <el-progress :percentage="uploadRate" />
          <div class="name" style="margin-top:10px;">
            {{fileName}}
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                周同比
              </div>
              <div class="ml-auto">
                <Tippy
                    tag="div"
                    class="report-box__indicator bg-theme-9 cursor-pointer"
                    content="33% Higher than last month"
                >
                  {{ staticData.assetWeekIncRatio }}
                  <ChevronUpIcon class="w-4 h-4"/>
                </Tippy>
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{ staticData.assetTotal }}</div>
            <div class="text-base text-gray-600 mt-1">资产总数</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                总管理面积
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{ staticData.areaTotal }}</div>
            <div class="text-base text-gray-600 mt-1">未出租面积{{ staticData.unRentArea }}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                欠收租金
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4"
                 style="white-space:nowrap;">
              {{ staticData.unPayment }} 元
            </div>
            <div class="text-base text-gray-600 mt-1">实收租金 {{ staticData.payment }}元</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                整体出租率
                <div class="text-2xl font-bold leading-8 mt-4">{{ staticData.rentRatio }}</div>
              </div>
              <div class="ml-auto">
                <el-progress type="circle" :percentage="percentVal" :width='86'></el-progress>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="intro-y mt-8">
      <div class="intro-y box p-5 mt-5" style='padding-bottom: 0;'>
        <el-form :form="form" inline>
          <el-form-item label="资产产权证地址:">
            <el-input v-model='form.certificateAddress' placeholder="请输入资产产权证地址" clearable/>
          </el-form-item>
          <el-form-item label="资产来源:">
            <el-select v-model="form.assetSource" placeholder="请选择资产来源">
              <el-option :label="item.key" :value="item.value" v-for="item in sourceOptions" :key="item.key" clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资产状态:">
            <el-select v-model="form.rentStatus" placeholder="请选择资产状态">
              <el-option :label="item.key" :value="item.value" v-for="item in statusOptions" :key="item.key" clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type='primary'  @click="searchHandle"> 搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table begin-->
      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report mt-2">
          <thead>
          <tr class="text-gray-700">
            <th class="text-center whitespace-no-wrap">资产产权证地址</th>
            <th class="text-center whitespace-no-wrap">资产来源</th>
            <th class="text-center whitespace-no-wrap">合同编号</th>
            <th class="text-center whitespace-no-wrap">合同开始时间</th>
            <th class="text-center whitespace-no-wrap">合同结束时间</th>
            <th class="text-center whitespace-no-wrap">建筑面积</th>
            <th class="text-center whitespace-no-wrap">状态</th>
            <th class="text-center whitespace-no-wrap">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(faker, fakerKey) in datas"
              :key="fakerKey"
              class="intro-x"
          >
            <td class="border-b dark:border-dark-5">
              {{ faker.certificateAddress }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.assetSource }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.contractNo }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.contractStartDate }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.contractEndDate }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.buildingArea }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.contractStatus }}
            </td>
            <td class="table-report__action w-40 border-b dark:border-dark-5">
              <div class="flex justify-center items-center">
                <a class="flex items-center mr-3 text-theme-1" href="javascript:;" @click="checkHandle(faker)">
                  查看
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- table end -->
      <!-- BEGIN: Pagination -->

      <!-- END: Pagination -->
    </div>
    <div class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
         style='justify-content: space-between'>
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size='form.perPage'
          :current-page='form.page'
          @current-change='handleTableChange'
          :total="total">
      </el-pagination>
      <select class="border w-20 input box mt-3 sm:mt-0" @change="pageSizeChange">
        <option>10</option>
        <option>25</option>
        <option>35</option>
        <option>50</option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  getList,
  addAssetByTemplate,
  getUploadProcess,
  getCompanyList,
  getAssetTemplate,
  getAssetStatistics,
  listToTree
} from '@/api/asset.js'
import {accountList} from '@/api/workbench.js'
export default {
  components: {
    // Cascader,
  },
  data() {
    return {
      loadingCheck: false,
      loadingSearch: false,
      staticData: {},
      processDesc:'',
      signal:0,
      successVisible: false,
      errorVisible: false,
      progressVisible: false,
      unitOptions: [],
      staffOptions:[
        {value:'',label:'全部员工'}
      ],
      cascaderProps: {
        value: 'id',
        label: 'name'
      },
      companyIds: [],
      staffId:'',
      form: {
        companyId: -1,
        userId:'',
        certificateAddress: '',
        assetSource: '',
        rentStatus: '',
        page: 1,
        perPage: 10,
      },
      total: 0,
      sourceOptions: [
        {value:'',key:'请选择'},
        {value: '托管', key: '托管'},
        {value: '不填报', key: '不填报'},
        {value: '租转', key: '租转'},
        {value: '集团公司', key: '集团公司'},
        {value: '自有', key: '自有'},
        {value: '国资委', key: '国资委'},
      ],
      statusOptions: [
        {value:'',key:'请选择'},
        {value: '0', key: '未出租'},
        {value: '1', key: '已出租'},
      ],
      columns: [
        {
          title: '管理单位名称',
          dataIndex: 'managementEnterprise',
          key: 'managementEnterprise',
        },
        {
          title: '资产编号',
          dataIndex: 'assetNumber',
          key: 'assetNumber',
        },
        {
          title: '资产产权证地址',
          dataIndex: 'certificateAddress',
          key: 'certificateAddress',
        },
        {
          title: '资产来源',
          dataIndex: 'assetSource',
          key: 'assetSource',
        },
        {
          title: '合同数量',
          dataIndex: 'contractCount',
          key: 'contractCount',
        },
        {
          title: '建筑面积',
          dataIndex: 'buildingArea',
          key: 'buildingArea',
        },
        {
          title: '状态',
          dataIndex: 'contractStatus',
          key: 'contractStatus',
        },
        {
          title: '操作',
          dataIndex: 'operate',
          key: 'operate',
          scopedSlots: {customRender: 'operate'},
        },
      ],
      datas: [],
      importResult: {},
      fileName: '闵行资产.xls',
      uploadRate: 0,
    }
  },
  computed: {
    percentVal: function () {
      if (this.staticData.rentRatio) {
        let num = this.staticData.rentRatio.replace(/%/g, '');
        return Number(num);
      } else {
        return 0;
      }

    }
  },
  methods: {
    getAccountList(){
        let para = {
          page:1,
          perPage:10000,
        }
        accountList(para).then(res => {
          let data = res.data
          let staffList=data.content.list;
          for(let i=0;i<staffList.length;i++){
            let staff = staffList[i]
            this.staffOptions.push({value:staff.id,label:staff.name})
          }
        })
    },
    onChange(val) {
      this.form.companyId = val[val.length - 1]
    },
    getStatic() {
      this.loadingCheck = true;
      getAssetStatistics({companyId: this.form.companyId}).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.staticData = data.content.assetStatistics;
          this.loadingCheck = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    hideModalSuccess() {
      this.successVisible = false;
    },
    hideModalError() {
      this.errorVisible = false;
    },
    getTemplate() {
      getAssetTemplate().then(res => {
        let data = res.data;
        if (data.code === '000') {
          let url = data.content.assetTemplate;
          let downLink = document.createElement('a');
          downLink.style.display = 'none';
          downLink.href = url;
          downLink.download = '楼管家资产上传模板';
          document.body.appendChild(downLink);
          downLink.click();
          document.body.removeChild(downLink);

        } else {
          console.log(data.desc)
        }
      })
    },
    checkData() {
      this.getStatic();
      this.searchHandle();
    },
    getCompanyLists() {
      getCompanyList().then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.unitOptions = listToTree(data.content.list);
        } else {
          console.log(data.desc)
        }
      })
    },
    initList() {
      this.loadingSearch = true;
      getList(this.form).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.datas = data.content.list;
          this.datas.map((item, index) => {
            item.index = index;
            return item;
          })
          this.total = data.content.total;
          this.loadingSearch = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    searchHandle() {
      this.form.page = 1;
      this.initList();
    },
    manualEntry() {
      this.$router.push({path: '/assetManagement/assetOperation', query: {operation: 'add'}});
    },
    getProcess(id){
      getUploadProcess({processId:id}).then(res=>{
        let data = res.data
        if(data.code === '000'){
          this.importResult = data.content.uploadResp;
          this.uploadRate = Number(data.content.process)||0;
          this.processDesc = data.content.processDesc;
          this.signal = data.content.signal;
          if(this.signal === 1){
            this.progressVisible = false;
            clearInterval(this.timer)
            this.timer = null;
            if (this.importResult.code === '000') {
              this.successVisible = true;
            } else {
              this.errorVisible = true;
            }
          }
          
        }else{
          console.log(data.desc)
        }
      })
    },
    tableImport() {
      let vm = this;
      let assetImportFile = document.createElement('input');
      assetImportFile.type = 'file';
      assetImportFile.id = 'assetImportFile';
      assetImportFile.accept = 'application/vnd.ms-excel';
      document.body.appendChild(assetImportFile);
      assetImportFile.click();
      assetImportFile.addEventListener('change', e => {
        this.progressVisible = true;
        let file = e.target.files[0];
        let formdata = new FormData();
        this.fileName = file.name;
        formdata.append('file', file);
        if (file) {
          addAssetByTemplate(formdata, vm).then(res => {
            let data = res.data;
            // this.progressVisible = false;
            // this.uploadRate = 100;
            if (data.code === '000') {
              let processId = data.content.processId;
              this.timer = setInterval(()=>{
                this.getProcess(processId)
              },1000)
              
              // this.importResult = data.content;
              // if (data.content.code === '000') {
              //   this.successVisible = true;
              // } else {
              //   this.errorVisible = true;
              // }
              this.getStatic();
              this.initList();
            } else {
              this.$message.warning(data.desc);
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    sourceChange(val) {
    },
    handleTableChange(page) {
      this.form.page = page;
      this.initList();
    },
    pageSizeChange(e) {
      this.form.page = 1;
      this.form.perPage = Number(e.target.value);
      this.initList();
    },
    checkHandle(val) {
      let url=this.$router.resolve({path: '/assetManagement/assetDetail', query: {assetId: val.assetId}}).href
      window.open(url)
    },
  },
  created() {
    this.getAccountList();
    this.initList();
    this.getCompanyLists();
    this.getStatic();
  }
};
</script>

